export const PROMOSKU = ["CAREKIT", "CAREKIT2"];
export const CAREKIT2SKUS = ["WCAREKIT2", "MCAREKIT2"];
export const PROMOSCALP = "SCTRAVELPROMO";
export const GACTIVATOR = "GACTIVATOR-N01";
export const HAIRSERUM = "HAIRSERUM-N01";
export const MHAIRSERUM = "MHAIRSERUM-N01";
export const HAIRSERUMSML = "HAIRSERUMSML-N01";
export const MHAIRSERUMSML = "MHAIRSERUMSML-N01";
export const HAIRSERUM_PROMO = "HAIRSERUM_PROMO-N01";
export const MHAIRSERUM_PROMO = "MHAIRSERUM_PROMO-N01";

/* Scalp Upsell Combo SKUs - used in cart upsell components */
export const SCALP_UPSELL_HAIR_SERUM_SKUS = [HAIRSERUMSML, MHAIRSERUMSML];
export const SCALP_UPSELL_SHAMPOO_SKUS = [
  "SCALPSCPROMO-N01",
  "ACTIVECLEANSE-N01",
  "STRANDSERUM-N01",
];

export const FHKDUOS1 = [
  "ADVGSML1-S01",
  "BALGSML1-S01",
  "POSGSML1-S01",
  "MENGSML1-S01",
  "MSRGSML1-S01",
];

export const SCALPSKUS = [
  "RPURIFIER-N01",
  "SDEFENDER-N01",
  "SCALPSCPROMO-N01",
  "SCALPSCTRAVEL-N01",
  "SCALPSC-N01",
  "SCALPSCGK-N01",
  "SCALPSCK-N01",
  "SCALPEKGSML-N01",
];

// Hair Serum SKUs for upsells
export const HAIRSERUM_SKUS = [
  "MHS_PROMO-N01",
  "HS_PROMO-N01",
  "MENGMSMLX3-S01",
  "MENGMSMLX6-S01",
  "MENDGMSMLX3-S01",
  "MENDGMSMLX6-S01",
  "MENCGMSMLX3-S01",
  "MENCGMSMLX6-S01",
  "MENCDGMSMLX3-S01",
  "MENCDGMSMLX6-S01",
];

// Active Cleanse SKUs for upsells
export const ACTIVECLEANSE_SKUS = [
  "MENX1-N01",
  "MENX1-S01",
  "MENX3-S01",
  "MENX6-S01",
  "MSRX1-N01",
  "MSRX1-S01",
  "MSRX3-S01",
  "MSRX6-S01",
  "MENGMSMLX1-S01",
  "MENGMSMLX3-S01",
  "MENGMSMLX6-S01",
  "MENDX1-S01",
  "MENDX3-S01",
  "MENDX6-S01",
  "MENDGMSMLX1-S01",
  "MENDGMSMLX3-S01",
  "MENDGMSMLX6-S01",
  "MENCX1-S01",
  "MENCX3-S01",
  "MENCX6-S01",
  "MENCGMSMLX1-S01",
  "MENCGMSMLX3-S01",
  "MENCGMSMLX6-S01",
  "MENCDGMSMLX1-S01",
  "MENCDGMSMLX3-S01",
  "MENCDGMSMLX6-S01",
  "SCALPSC_PROMO-N01",
  "ACTIVECLEANSE-N01",
];

export const CORE_SKUS_SUB = ["ADV1-S01", "BAL1-S01", "POS1-S01", "MENPRO1-S01", "MSR1-S01"];

export const CORE_SKUS_ONETIME_WOMEN = ["ADV1-N01", "BAL1-N01", "POS1-N01"];
export const CORE_SKUS_ONETIME_MEN = ["MENPRO1-N01", "MSR1-N01"];
export const CORE_SKUS_ONETIME = [...CORE_SKUS_ONETIME_WOMEN, ...CORE_SKUS_ONETIME_MEN];

export const CORE_SKUS_SUB_THREE_PACK = [
  "ADV3-S01",
  "BAL3-S01",
  "POS3-S01",
  "MENPRO3-S01",
  "MSR3-S01",
];
export const CORE_SKUS_SUB_SIX_PACK = [
  "ADV6-S01",
  "BAL6-S01",
  "POS6-S01",
  "MENPRO6-S01",
  "MSR6-S01",
];

export const DUO_SKUS = [
  "ADVAS1-S01",
  "ADVAH1-S01",
  "ADVAC1-S01",
  "ADVAM1-S01",
  "ADVAT1-S01",
  "ADVAB1-S01",

  "BALAS1-S01",
  "BALAH1-S01",
  "BALAC1-S01",
  "BALAM1-S01",
  "BALAT1-S01",
  "BALAB1-S01",

  "MENAC1-S01",
  "MENAS1-S01",
  "MENAH1-S01",
  "MENAB1-S01",
  "MENAD1-S01",
  "MENAT1-S01",

  "MSRAC1-S01",
  "MSRAS1-S01",
  "MSRAH1-S01",
  "MSRAB1-S01",
  "MSRAD1-S01",
  "MSRAT1-S01",
];

export const DUO_ONE_PACK = [
  ...DUO_SKUS,
  //MEN
  "MENX1-S01",
  "MENFUL1-S01",
  //MEN 50
  "MSRX1-S01",
  "MSRFUL1-S01",
];

export const DUO_THREE_PACK = [
  "ADVAS3-S01",
  "ADVAH3-S01",
  "ADVAC3-S01",
  "ADVAM3-S01",
  "ADVAT3-S01",
  "ADVAB3-S01",
  "BALAS3-S01",
  "BALAH3-S01",
  "BALAC3-S01",
  "BALAM3-S01",
  "BALAT3-S01",
  "BALAB3-S01",

  "MENAC3-S01",
  "MENAS3-S01",
  "MENAH3-S01",
  "MENAB3-S01",
  "MENAD3-S01",
  "MENAT3-S01",

  "MSRAC3-S01",
  "MSRAS3-S01",
  "MSRAH3-S01",
  "MSRAB3-S01",
  "MSRAD3-S01",
  "MSRAT3-S01",

  //MEN
  "MENX3-S01",
  "MENFUL3-S01",
  //MEN 50
  "MSRX3-S01",
  "MSRFUL3-S01",
];

export const DUO_SIX_PACK = [
  "ADVAS6-S01",
  "ADVAH6-S01",
  "ADVAC6-S01",
  "ADVAM6-S01",
  "ADVAT6-S01",
  "ADVAB6-S01",
  "BALAS6-S01",
  "BALAH6-S01",
  "BALAC6-S01",
  "BALAM6-S01",
  "BALAT6-S01",
  "BALAB6-S01",

  "MENAC6-S01",
  "MENAS6-S01",
  "MENAH6-S01",
  "MENAB6-S01",
  "MENAD6-S01",
  "MENAT6-S01",

  "MSRAC6-S01",
  "MSRAS6-S01",
  "MSRAH6-S01",
  "MSRAB6-S01",
  "MSRAD6-S01",
  "MSRAT6-S01",

  //MEN
  "MENX6-S01",
  "MENFUL6-S01",
  //MEN 50
  "MSRX6-S01",
  "MSRFUL6-S01",
];
